import TrendingUpIcon from "../../resources/icons/trending-up.svg";
import TrendingDownIcon from "../../resources/icons/trending-down.svg";

const TrendIndicator = (props) => {
  const trendValue = typeof props === "string" ? props : props?.trendValue;
  const testId =
    typeof props === "string" ? "trend-indicator" : (props?.testId ?? "trend-indicator");
  const positionClass =
    typeof props === "string"
      ? "absolute top-4 right-4"
      : (props?.className ?? "absolute top-4 right-4");

  if (!trendValue) return null;

  const isPositive = trendValue.startsWith("+");
  const isNegative = trendValue.startsWith("-");

  if (isPositive) {
    return (
      <div
        id={`${testId}-positive`}
        className={`${positionClass} bg-green-100 text-green-600 px-2 py-1 rounded text-sm font-medium`}
      >
        <div className="flex gap-2">
          <div className="flex items-center">
            <img
              src={TrendingUpIcon}
              alt="Trending Up Icon"
              className="w-5 h-5"
            />
          </div>
          <div>{trendValue}</div>
        </div>
      </div>
    );
  } else if (isNegative) {
    return (
      <div
        id={`${testId}-negative`}
        className={`${positionClass} bg-red-100 text-red-600 px-2 py-1 rounded text-sm font-medium`}
      >
        <div className="flex gap-2">
          <div className="flex items-center">
            <img
              src={TrendingDownIcon}
              className="w-5 h-5"
              alt="Trending Down Icon"
            />
          </div>
          <div>{trendValue}</div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        id={`${testId}-neutral`}
        className={`${positionClass} bg-gray-100 text-gray-600 px-2 py-1 rounded text-sm font-medium`}
      >
        <div className="flex gap-2">
          <div>{trendValue}</div>
        </div>
      </div>
    );
  }
};

export default TrendIndicator;
